module.exports = __webpack_public_path__ + "img/troiseme.477b525f.png";